import React from "react";
import "./Alert.css";

export default function Alert({ type = "info", children, onDismiss }) {
  if (!children) {
    return null;
  }
  return (
    <div className={`alert alert-${type}`}>
      <span>{children}</span>
      {onDismiss && (
        <button type="button" className="alert-dismiss" onClick={onDismiss} aria-label="Dismiss">
          &times;
        </button>
      )}
    </div>
  );
}
